// const base_url = "http://127.0.0.1:5000";

// PRODUCTION
const base_url = "https://70d5yd0sxi.execute-api.us-east-2.amazonaws.com/dev";

// STAGING
// const base_url = "http://3.135.192.56:8080";

export default base_url;
